import { render } from "./leave-report-table.vue?vue&type=template&id=e6dd79e6"
import script from "./leave-report-table.vue?vue&type=script&lang=js"
export * from "./leave-report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__